module.exports = __webpack_public_path__ + "static/img/righticon1.82162fe1.png";